import { Link } from "react-router";
import { useI18n } from "@wato/i18n/react";
import { Stack } from "@wato/ui";
import { LanguageToggle } from "./common";

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-surface-muted">
      <div className="mx-auto flex max-w-md flex-col gap-6 px-6 py-16">
        <div className="self-end">
          <LanguageToggle />
        </div>
        <Stack gap={2}>
          <h1 className="text-2xl font-semibold text-fg">{t("dashboard.shell.notFoundTitle")}</h1>
          <p className="text-sm text-fg-muted">{t("dashboard.shell.notFoundBody")}</p>
        </Stack>
        <Link className="font-semibold text-on-action-ghost underline" to="/">
          {t("dashboard.shell.backHome")}
        </Link>
      </div>
    </div>
  );
}
